import useAccount from '~/hooks/useAccount';
import useFeature from '~/hooks/useFeature';

export const useSystemConsole = () => {
  const { id: hostingId } = useAccount();

  const [hasAdvancedHosting] = useFeature('advanced_hosting', hostingId);
  const [isPlesk] = useFeature('plesk', hostingId);
  const [isWindows] = useFeature('windows', hostingId);

  return {
    hostingId,
    canShow: hasAdvancedHosting && !isPlesk && !isWindows,
  };
};
